import { Divider, OutlinedInput } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { handleClickOutsideCloseDropdown } from "./utils/utils";

function InputSearchRefund({ searchData }) {
  const [inputValue, setInputValue] = useState("");
  const [attributeName, setAttributeName] = useState("transactionId");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const firstUpdateRef = useRef(true);

  const handleDropdownChange = (value) => {
    setAttributeName(value);
    setIsDropdownOpen(false);
    setInputValue("")
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSubmit = () => {
    searchData(attributeName, inputValue);
  };
  useEffect(() => {
    if (firstUpdateRef.current) {
      firstUpdateRef.current = false;
      return
    }
    handleSubmit();
  }, [attributeName, inputValue]);

  const dropdownRef = useRef(null);
  useEffect(() => {
    const clickHandler = (event) =>
      handleClickOutsideCloseDropdown(event, dropdownRef, setIsDropdownOpen);

    document.addEventListener("click", clickHandler);
    return () => {
      document.removeEventListener("click", clickHandler);
    };
  }, []);

  return (
    <>
      <div
        className="btn-group"
        style={{
          borderRadius: "8px",
          height: "42px",
          width: "100%",
          border: "1px solid var(--text-disabled, rgba(1, 1, 2, 0.12))",
        }}
        ref={dropdownRef}
      >
        <div
          style={{
            marginTop: "8px",
            marginLeft: "8px",
          }}
        >
          <div
            className="dropdown"
            style={{
              display: "inline-block",
              position: "relative",
              cursor: "pointer",
            }}
          >
            <div
              className="dropdown-toggle"
              onClick={handleDropdownToggle}
              style={{
                cursor: "pointer",
                paddingLeft: "10px",
                color: "var(--text-high, rgba(1, 1, 2, 0.72))",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {attributeName === "transactionId" && "Transaction ID"}
              {attributeName === "orderId" && "Order ID"}
              {attributeName === "shopper.phoneNumber" && "Mobile Number"}
              {attributeName === "shopper.email" && "Email"}
              {attributeName === "shopper.name" && "Name"}
              {attributeName === "authCode" && "Bank Reference"}
            </div>
            {isDropdownOpen && (
              <div
                className="dropdown-menu"
                style={{
                  display: "block",
                  marginTop: "12px",
                  width: "200px",
                  marginLeft: "-12px",
                }}
              >
                <div
                  className="dropdown-item dropdownContentStyling"
                  onClick={() => handleDropdownChange("transactionId")}
                >
                  Transaction ID
                </div>
                <div
                  className="dropdown-item dropdownContentStyling"
                  onClick={() => handleDropdownChange("orderId")}
                >
                  Order ID
                </div>
                <div
                  className="dropdown-item dropdownContentStyling"
                  onClick={() => handleDropdownChange("shopper.name")}
                >
                  Name
                </div>
                <div
                  className="dropdown-item dropdownContentStyling"
                  onClick={() => handleDropdownChange("shopper.email")}
                >
                  Email
                </div>
                <div
                  className="dropdown-item dropdownContentStyling "
                  onClick={() => handleDropdownChange("shopper.phoneNumber")}
                >
                  Mobile Number
                </div>
                <div
                  className="dropdown-item dropdownContentStyling"
                  onClick={() => handleDropdownChange("authCode")}
                >
                  Bank Reference
                </div>
              </div>
            )}
          </div>
        </div>
        <span
          style={{
            marginBottom: "10px",
            marginTop: "10px",
            marginLeft: "10px",
          }}
        >
          <Divider orientation="vertical" color="#C2C2C2" />
        </span>
        <BiSearch
          style={{
            marginTop: "7px",
            height: "28px",
            width: "28px",
            color: "#C2C2C2",
            marginRight: "4px",
            marginLeft: "8px",
          }}
        />
        <input
          type="text"
          value={inputValue}
          onChange={(eve) => setInputValue(eve.target.value)}
          style={{
            border: "none",
            borderRadius: "8px",
            outline: "none",
            marginLeft: "-4px",
            fontSize: "14px",
            width: "inherit",
          }}
          placeholder="Search"
        />
      </div>
    </>
  );
}

export default InputSearchRefund;
